import { type IntlShape } from 'react-intl'

export const directContactFormAccessorIsProductType = (
  intl: IntlShape,
  subject: string,
): boolean => {
  const productType = new Set([
    intl.formatMessage({ id: 'direct.contact.form.order.cancellation' }),
    intl.formatMessage({
      id: 'direct.contact.form.order.missing.or.incorrect.item',
    }),
    intl.formatMessage({ id: 'direct.contact.form.report.order' }),
    intl.formatMessage({ id: 'direct.contact.form.return.order' }),
  ])

  return productType.has(subject)
}
